import { render, staticRenderFns } from "./PasswordNew.vue?vue&type=template&id=d58907d4&scoped=true&"
import script from "./PasswordNew.vue?vue&type=script&lang=js&"
export * from "./PasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./PasswordNew.vue?vue&type=style&index=0&id=d58907d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58907d4",
  null
  
)

export default component.exports